import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import './App.css';
import Router from './routes';

export default function App() {
	const {pathname} = useLocation();

	const callPageViewTrackerAPI = (route = '') => {
		const url = process.env.REACT_APP_PAGEVIEW_LAMBDA;
		fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'route': route,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(
			function (response) {
				return response;
			}
		).catch(
			function(error) {
				console.log("PAGEVIEW:", error)
			}
		);
	}

	useEffect(() => {
		window.scrollTo(0, 0);
		callPageViewTrackerAPI(pathname);
	}, [pathname]);

	useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
				callPageViewTrackerAPI();
            } else {
				callPageViewTrackerAPI(pathname);
			};
		};

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

	useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
			callPageViewTrackerAPI();
            event.returnValue = ''; // Required for Chrome to show the confirmation dialog
		};

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
	
	useEffect(() => {
        ReactGA.initialize(process.env.REACT_APP_TRACKING_ID);
    }, [])

	return (
		<Router />
	);
}